import { useCallback } from 'react';

import { Switch, Inline, Text, CameraFillIcon, u } from '@ui';

import * as css from './InstantPlayback.css';

interface InstantPlaybackProps {
    isActive: boolean;
    onUpdate: (value: boolean) => void;
    label: string;
}

export function InstantPlayback({ isActive, onUpdate, label }: InstantPlaybackProps) {
    const handleClick = useCallback(() => {
        onUpdate(!isActive);
    }, [onUpdate, isActive]);
    return (
        <Inline
            gap={u(2)}
            alignItems="center"
            px={u(3)}
            className={css.switchSection}
            role="button"
            onClick={handleClick}
        >
            <CameraFillIcon />
            <Text variant="h3" whiteSpace="nowrap" style={{ marginRight: 'auto' }}>
                {label}
            </Text>
            <Switch value={isActive} />
        </Inline>
    );
}
